const DESKTOP_MONTH_CARD_WIDTH = 372;
const DESKTOP_MONTH_GRID_GAP = 8;
const DESKTOP_CALENDAR_SIDE_PADDING = 32;
const MAX_YEAR_COLUMNS = 4;
const DEFAULT_DESKTOP_YEAR_COLUMNS = 2;

interface GetDesktopYearColumnsParams {
    containerWidth: number;
}

export const getDesktopYearColumns = ({
    containerWidth,
}: GetDesktopYearColumnsParams): number => {
    if (containerWidth <= 0) {
        return DEFAULT_DESKTOP_YEAR_COLUMNS;
    }

    const availableWidth = Math.max(
        0,
        containerWidth - DESKTOP_CALENDAR_SIDE_PADDING * 2
    );

    const availableColumns = Math.floor(
        (availableWidth + DESKTOP_MONTH_GRID_GAP)
        / (DESKTOP_MONTH_CARD_WIDTH + DESKTOP_MONTH_GRID_GAP)
    );

    return Math.max(1, Math.min(MAX_YEAR_COLUMNS, availableColumns));
};

